export default __webpack_public_path__ + "static/media/image-20.38de563b.png";